<script>
// An "All day / Closed" checkbox plus start and end `type="time"` inputs,
// shared by the Layer-0/Layer-3 date override modal, agent leave and
// one-off assignment time slots (docs/real-estate/be/10-api-reference.md
// §A7-A10). Both times are sent as `null` when the box is ticked — the
// BE 422s if only one of the two is set, so this component only ever
// emits a fully-null or fully-filled pair.
//
// `value`/`input` form a v-model over `{ start_time, end_time }`. Assignment
// time slots have no "all day" concept at all (§A10) — pass
// `:show-all-day="false"` to hide the checkbox and always show both times.
export default {
  name: 'TimeRangeFields',
  props: {
    value: {
      type: Object,
      required: true,
    },
    allDayLabel: {
      type: String,
      default: '',
    },
    showAllDay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isAllDay:
        this.showAllDay &&
        this.value.start_time == null &&
        this.value.end_time == null,
      startTime: this.value.start_time || '',
      endTime: this.value.end_time || '',
    };
  },
  methods: {
    emitChange() {
      this.$emit('input', {
        start_time: this.isAllDay ? null : this.startTime,
        end_time: this.isAllDay ? null : this.endTime,
      });
    },
  },
};
</script>

<template>
  <div class="flex flex-wrap items-center gap-2">
    <label
      v-if="showAllDay"
      class="flex items-center gap-1.5 mb-0 text-sm text-slate-700 dark:text-slate-200 shrink-0 font-normal"
    >
      <input v-model="isAllDay" type="checkbox" @change="emitChange" />
      {{ allDayLabel }}
    </label>
    <template v-if="!isAllDay">
      <input
        v-model="startTime"
        type="time"
        class="bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg py-1.5 px-2 text-sm text-slate-900 dark:text-slate-100"
        @change="emitChange"
      />
      <span class="text-slate-400">–</span>
      <input
        v-model="endTime"
        type="time"
        class="bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-lg py-1.5 px-2 text-sm text-slate-900 dark:text-slate-100"
        @change="emitChange"
      />
    </template>
  </div>
</template>
